const FileTypes = {
  images: ".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*",
  pngs: ".png|image/*",
  videos: "video/*",
  audio: "audio/*",
  word: "application/msword",
  excel: "application/vnd.ms-excel,application/vnd.ms-excel*",
  pdf: "application/pdf",
  autoCAD:
    ".x_t,.stp,.stl,.sldprt,.sldasm,.x_b,.dxf,.dxf|application/acad,application/sldworks,image/x-dwg,image/x-dxf,drawing/*",
  csv: "text/csv",
  any: "*",
};

export default FileTypes;
